import {
  ACCESS_ROLES,
  ACCESS_ROLES_WITHOUT_NO_ACCESS,
  AccessRolesStructureType,
  RoleType,
  accessRolesStructure,
  accessRolesStructureWithoutNoAccess,
} from '@constants';
import { useGrowthBookFlag } from './useGrowthBookFlag';

type AccessRoles = {
  /** Flat list, for single-role pickers. */
  accessRoles: RoleType[];
  /** Grouped list, for the Modify Access Level menus. */
  accessRolesStructure: AccessRolesStructureType[];
};

/**
 * The access levels Galaxy offers. With memberManagementTableV2Flag on, No Access is gone
 * (GLX-2013): members who should not sign in are set Inactive instead.
 */
export const useAccessRoles = (): AccessRoles => {
  const { isOn } = useGrowthBookFlag('memberManagementTableV2Flag');

  return isOn
    ? {
        accessRoles: ACCESS_ROLES_WITHOUT_NO_ACCESS,
        accessRolesStructure: accessRolesStructureWithoutNoAccess,
      }
    : { accessRoles: ACCESS_ROLES, accessRolesStructure };
};
